export const TIMELINE = {
  HEIGHT: 50,
  EVENT_RECT: {
    WIDTH: 5,
    HEIGHT: 10,
    SELECT_SCALE: 1.3,
    COLOR: '#b0d3f5',
    SELECTED_COLOR: '#1d8bf5',
  },
  BASE_LINE_COLOR: '#eee',
};
